module.exports = __webpack_public_path__ + "img/BearWalking.dcac8443.gif";